import { render, staticRenderFns } from "./decoration6.vue?vue&type=template&id=0cc17b3d&scoped=true"
import script from "./decoration6.vue?vue&type=script&lang=js"
export * from "./decoration6.vue?vue&type=script&lang=js"
import style0 from "./decoration6.vue?vue&type=style&index=0&id=0cc17b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc17b3d",
  null
  
)

export default component.exports